import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import EstadisticasProveedores from './EstadisticasProveedores';
import BuscadorProveedores from './BuscadorProveedores';
import './App.css';

// Material-UI imports
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Container, 
  Box, 
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import { 
  Search as SearchIcon,
  Assessment as AssessmentIcon
} from '@mui/icons-material';

// Tema Material-UI
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#f50057',
    },
  },
});

// Configuración de API base - usa directamente Cloudflare Workers en producción
const API_BASE = process.env.REACT_APP_API_URL || 'https://municipal-dashboard-api.repasador-alpargata.workers.dev/api';

function App() {
  const [tabValue, setTabValue] = useState(0);

  // Estados para búsqueda y filtros
  const [busqueda, setBusqueda] = useState('');
  const [provinciaFilter, setProvinciaFilter] = useState('');
  const [actividadFilter, setActividadFilter] = useState('');

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const filtrarPorProvincia = (provincia) => {
    setProvinciaFilter(provincia);
    setBusqueda(provincia);
    setTabValue(0); // Cambiar a la tab de proveedores
  };

  const filtrarPorActividad = (actividad) => {
    setActividadFilter(actividad);
    setBusqueda(actividad);
    setTabValue(0); // Cambiar a la tab de proveedores
  };

  const renderTabContent = () => {
    switch (tabValue) {
      case 1:
        return <EstadisticasProveedores 
          onFiltrarProvincia={filtrarPorProvincia} 
          onFiltrarActividad={filtrarPorActividad} 
        />;
      default:
        return (
          <BuscadorProveedores 
            apiBase={API_BASE}
            busquedaInicial={busqueda} 
            provinciaFilter={provinciaFilter}
            actividadFilter={actividadFilter}
          />
        );
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" elevation={1}>
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              📊 Sistema de Proveedores Municipales
            </Typography>
            <Typography variant="body2" sx={{ ml: 2 }}>
              Dashboard de Consultas
            </Typography>
          </Toolbar>
        </AppBar>

        <Container maxWidth={false} sx={{ 
          mt: 4, 
          mb: 4, 
          maxWidth: '1400px',
          margin: '0 auto'
        }}>
          <Paper sx={{ p: 3 }}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}
            >
              <Tab 
                icon={<SearchIcon />} 
                label="Proveedores" 
                iconPosition="start"
              />
              <Tab 
                icon={<AssessmentIcon />} 
                label="Estadísticas" 
                iconPosition="start"
              />
            </Tabs>            {renderTabContent()}
          </Paper>
        </Container>
      </Box>
    </ThemeProvider>
  );
}

export default App;